<div
  class="blog-image"
  [ngClass]="{
    'full-screen-image-section': type == 'FullScreenImageSection',
    'image-section': type == 'ImageSection',
    'image-with-big-caption-section': type == 'ImageWithBigCaptionSection',
    'image-with-caption-section': type == 'ImageWithCaptionSection'
  }"
  [style.marginTop.px]="marginService.getCurrentMargin(margin)"
>
  <ng-container>
    <app-img [src]="section?.image?.url" [newOptions]="section?.image">
    </app-img>
    <div
      *ngIf="type === 'ImageWithCaptionSection'"
      class="content-wrapper"
      [ngClass]="{ 'to-right': !section?.left }"
    >
      <h3 class="heading">{{ section.title }}</h3>
      <a class="link-to-more text-link" [href]="section.linkDestination">{{
        section.linkDescription
      }}</a>
    </div>
    <div *ngIf="type == 'ImageWithBigCaptionSection'" class="big-caption">
      <p>{{ section.text }}</p>
    </div>
  </ng-container>
</div>
